import { render, staticRenderFns } from "./monitorPointRemindConfigDialog.vue?vue&type=template&id=d7fd7384&scoped=true"
import script from "./monitorPointRemindConfigDialog.vue?vue&type=script&lang=js"
export * from "./monitorPointRemindConfigDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7fd7384",
  null
  
)

export default component.exports